import { useEffect, useState } from 'react'
import { api, session } from '../api.js'
import ChercherPersonne from './ChercherPersonne.jsx'

// Tout ce qui concerne « qui traite cette démarche », sans quitter la démarche.
// Le point important n'est pas d'éviter des clics : c'est de montrer le
// résultat. Avant, on réglait trois choses sur trois écrans sans jamais voir
// qui, concrètement, allait recevoir les demandes.
export default function AccesDemarche({ formKey }) {
  const [data, setData] = useState(null)
  const [message, setMessage] = useState('')
  const [erreur, setErreur] = useState('')
  const [nouveauService, setNouveauService] = useState('')
  const [nouvelAgent, setNouvelAgent] = useState(null)
  const [replie, setReplie] = useState(true)

  const charger = () => { api.formAcces(formKey).then(setData).catch((e) => setErreur(e.message)) }
  useEffect(() => { charger() }, [formKey])   // eslint-disable-line

  if (!data) return <p className="chargement">{erreur || 'Chargement…'}</p>
  const lectureSeule = session.env === 'live'

  async function regler(payload) {
    try {
      const r = await api.reglerAcces(formKey, payload)
      setMessage(r.message || 'Enregistré.')
      setErreur('')
      charger()
    } catch (e) { setErreur(e.message) }
  }

  const avecAcces = data.agents.filter((a) => a.acces)

  return (
    <>
      {message && <p className="succes" role="status">{message}</p>}
      {erreur && <p className="erreur" role="alert">{erreur}</p>}

      <div className="resume-acces">
        <strong>{data.resume}</strong>
      </div>

      <div className="deux">
        <section className="carte">
          <h2>Qui répond à ces demandes</h2>

          <div className="champ">
            <label htmlFor="a-svc">Service en charge</label>
            <select id="a-svc" value={data.service_key || ''} disabled={lectureSeule}
                    onChange={(e) => {
                      if (e.target.value === '__nouveau') setNouveauService(' ')
                      else regler({ service_key: e.target.value })
                    }}>
              <option value="">Personne en particulier</option>
              {data.services.map((s) => <option key={s.key} value={s.key}>{s.name}</option>)}
              {!lectureSeule && <option value="__nouveau">Créer un service…</option>}
            </select>
            <p className="aide">Les nouveaux dossiers arrivent dans la liste de cette équipe.
              Toute l'équipe peut les traiter, même quand quelqu'un est absent.</p>
          </div>

          {nouveauService !== '' && (
            <div className="champ encadre">
              <label htmlFor="a-new">Nom du nouveau service</label>
              <input id="a-new" autoFocus value={nouveauService.trim()}
                     placeholder="Accueil et état civil"
                     onChange={(e) => setNouveauService(e.target.value || ' ')} />
              <div className="ligne">
                <button className="btn sm" onClick={() => setNouveauService('')}>Annuler</button>
                <button className="btn sm pri" disabled={!nouveauService.trim()}
                        onClick={() => {
                          regler({ service_nouveau: nouveauService.trim() })
                          setNouveauService('')
                        }}>Créer et rattacher</button>
              </div>
            </div>
          )}

          <div className="champ">
            <label htmlFor="a-lect">Qui peut consulter ces demandes</label>
            <select id="a-lect" value={data.read_scope} disabled={lectureSeule}
                    onChange={(e) => regler({ read_scope: e.target.value })}>
              <option value="service">Seulement les personnes ci-contre</option>
              <option value="tous">Tous les agents de la mairie</option>
            </select>
            {data.read_scope === 'service' && (
              <p className="aide">À garder pour les démarches sensibles : logement, aide sociale,
                signalement.</p>
            )}
          </div>
        </section>

        <section className="carte">
          <div className="ligne">
            <h2>Qui aura accès</h2>
            <div className="pousse" />
            <span className="compteur">{avecAcces.length}</span>
          </div>

          {!lectureSeule && (
            <ChercherPersonne
              gens={data.agents}
              placeholder="Chercher une personne, ou taper un nouveau nom…"
              onChoisir={(p) => (p.acces ? setMessage(`${p.name} a déjà accès à cette démarche.`)
                                         : regler({ ajouter: p.id }))}
              onCreer={(prerempli) => setNouvelAgent(prerempli)} />
          )}

          {/* La liste montre d'abord ceux qui ont accès : c'est la réponse à la
              question posée. Le reste de la collectivité se déplie au besoin. */}
          <ul className="acces-liste">
            {(replie ? avecAcces : data.agents).map((a) => (
              <li key={a.id} className={a.acces ? 'oui' : 'non'}>
                <div>
                  <strong>{a.name}</strong>
                  <span className="role">{a.role}</span>
                  {a.motif && <span className="motif">{a.motif}</span>}
                  {!a.acces && <span className="motif">n'a pas accès</span>}
                  {a.acces && !a.peut_traiter && (
                    <span className="motif">consultation seulement, son rôle ne permet pas de traiter</span>
                  )}
                </div>
                {!lectureSeule && !a.partout && (
                  a.acces && (a.dans_service || a.en_direct)
                    ? <button className="btn sm" onClick={() => regler({ retirer: a.id })}>Retirer</button>
                    : !a.acces && <button className="btn sm pri"
                                          onClick={() => regler({ ajouter: a.id })}>Donner accès</button>
                )}
              </li>
            ))}
            {!avecAcces.length && replie && (
              <li className="aide">Personne n'a accès pour l'instant.</li>
            )}
          </ul>

          {data.agents.length > avecAcces.length && (
            <button className="lien-mini" onClick={() => setReplie(!replie)}>
              {replie
                ? `Voir les ${data.agents.length - avecAcces.length} autres personnes de la collectivité`
                : 'Ne montrer que ceux qui ont accès'}
            </button>
          )}

          {nouvelAgent && (
            <NouvelAgent prerempli={nouvelAgent} onAnnuler={() => setNouvelAgent(null)}
                         onValider={(a) => { regler({ nouvel_agent: a }); setNouvelAgent(null) }} />
          )}
        </section>
      </div>
    </>
  )
}

// Créer le compte et lui ouvrir la démarche d'un seul geste : c'est une seule
// intention dans la tête de la personne qui le fait.
function NouvelAgent({ prerempli, onValider, onAnnuler }) {
  // Ce qui a été tapé dans la recherche est repris ici : on ne fait pas
  // retaper un nom qu'on vient d'écrire.
  const [a, setA] = useState({ name: prerempli?.name || '', email: prerempli?.email || '',
                               role: 'agent' })

  return (
    <div className="carte encadre">
      <h3>Nouvelle personne</h3>
      <div className="ligne-champs">
        <div className="champ">
          <label htmlFor="n-nom">Nom et prénom</label>
          <input id="n-nom" autoFocus={!prerempli?.name} value={a.name}
                 onChange={(e) => setA({ ...a, name: e.target.value })} />
        </div>
        <div className="champ">
          <label htmlFor="n-mail">Adresse électronique</label>
          <input id="n-mail" type="email" autoFocus={!!prerempli?.name} value={a.email}
                 onChange={(e) => setA({ ...a, email: e.target.value })} />
          <p className="aide">Si cette personne travaille déjà pour une autre collectivité sur
            UCIVIS, elle gardera son mot de passe habituel.</p>
        </div>
      </div>
      <div className="champ">
        <label htmlFor="n-role">Ce qu'elle pourra faire</label>
        <select id="n-role" value={a.role} onChange={(e) => setA({ ...a, role: e.target.value })}>
          <option value="accueil">Consulter seulement</option>
          <option value="agent">Traiter les dossiers</option>
          <option value="responsable">Traiter et configurer la plateforme</option>
        </select>
      </div>
      <p className="aide">Un mot de passe provisoire sera affiché, à lui transmettre.</p>
      <div className="ligne">
        <button className="btn" onClick={onAnnuler}>Annuler</button>
        <button className="btn pri" disabled={!a.name.trim() || !a.email.trim()}
                onClick={() => onValider(a)}>Ajouter et donner accès</button>
      </div>
    </div>
  )
}

